export default __webpack_public_path__ + "static/n_01-ab422c36da4f5adecd50d73ccfd68718.png";